exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".explore-card-list {\n  position: relative;\n}\n\n.explore-card-list .card-notification {\n  background: #00aa5e;\n  position: absolute;\n  border-radius: 50%;\n  top: 11px;\n  right: 11px;\n  width: 10px;\n  height: 10px;\n  border-style: solid;\n  border-color: #00aa5e;\n  border-width: thick;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/glass/notification/CardNotification.scss
// module id = 227
// module chunks = 0